// import styles
import "./Dashboard.css";

// import pacchetti
import Select from "react-select";
import { useState, useEffect } from "react";

// Filtri per stato di completamento
const completamentoFilters = [
  { value: "tutti", label: "Tutti" },
  { value: "completato", label: "Completato" },
  { value: "in-corso", label: "In corso" },
];

// Filtri predefiniti che saranno sempre disponibili (senza completati e scaduti)
const defaultFilters = [{ value: "tutti", label: "Tutti" }];

// Filtri per tipo di progetto (senza centri di costo, gestiti da toggle dedicato)
const tipoProjectFilters = [
  { value: "tutti", label: "Tutti i tipi" },
  { value: "cantiere", label: "Cantieri" },
  { value: "commessa", label: "Commesse" },
];

export default function ProjectFilter({
  filtro,
  change,
  onSearch,
  settori,
  tipoProjectFilter,
  onTipoProjectChange,
  completamentoFilter,
  onCompletamentoChange,
  showArchived,
  onToggleArchived,
  showCostCenters,
  onToggleCostCenters,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);

  // Prepara le opzioni per il dropdown combinando i filtri predefiniti con i settori
  useEffect(() => {
    if (settori) {
      const settoriOptions = settori.map((settore) => ({
        value: settore.nome,
        label: `Settore ${settore.nome}`,
      }));

      setFilterOptions([...defaultFilters, ...settoriOptions]);
    } else {
      setFilterOptions(defaultFilters);
    }
  }, [settori]);

  // Gestisce il cambio del filtro dal dropdown
  const handleFilterChange = (option) => {
    change(option.value);
  };

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    // Passa il termine di ricerca al componente padre
    onSearch(term);
  };

  // Trova l'opzione corrente selezionata
  const currentOption =
    filterOptions.find((option) => option.value === filtro) || filterOptions[0];

  // Trova l'opzione corrente per il tipo di progetto
  const currentTipoProjectOption =
    tipoProjectFilters.find((option) => option.value === tipoProjectFilter) ||
    tipoProjectFilters[0];

  // Trova l'opzione corrente per il completamento
  const currentCompletamentoOption =
    completamentoFilters.find(
      (option) => option.value === completamentoFilter,
    ) || completamentoFilters[0];

  // Gestisce il cambio del filtro per tipo di progetto
  const handleTipoProjectChange = (option) => {
    onTipoProjectChange(option.value);
  };

  // Gestisce il cambio del filtro per completamento
  const handleCompletamentoChange = (option) => {
    onCompletamentoChange(option.value);
  };

  return (
    <div className="project-filter">
      <div className="filters-container">
        <input
          type="text"
          onChange={handleSearchChange}
          placeholder="Cerca"
          className="search-bar"
          value={searchTerm}
        />

        <div className="dropdown-filters">
          <div className="toggle-group">
            <label className="toggle-option">
              <input
                type="checkbox"
                checked={!!showArchived}
                onChange={(e) => onToggleArchived(e.target.checked)}
              />
              Archiviati
            </label>
            <label className="toggle-option">
              <input
                type="checkbox"
                checked={!!showCostCenters}
                onChange={(e) => onToggleCostCenters(e.target.checked)}
              />
              CDCosto
            </label>
          </div>
          <Select
            className="filter-select"
            options={completamentoFilters}
            onChange={handleCompletamentoChange}
            value={currentCompletamentoOption}
            placeholder="Stato completamento"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={filterOptions}
            onChange={handleFilterChange}
            value={currentOption}
            placeholder="Seleziona filtro"
            isSearchable={false}
          />
          <Select
            className="filter-select"
            options={tipoProjectFilters}
            onChange={handleTipoProjectChange}
            value={currentTipoProjectOption}
            placeholder="Tipo di progetto"
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  );
}
